module.exports = kolibriCoreAppGlobal.coreVue.components.FullNameTextbox;